var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('b-img',{attrs:{"src":require('../assets/image/Back.jpg'),"fluid":"","alt":"Go back","width":"30em","onClick":"window.history.back();"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }